import { createSlice } from '@reduxjs/toolkit'
import localStorage from 'redux-persist/es/storage'

// Optimize localStorage access to prevent blocking
const getTokenFromStorage = () => {
    try {
        const token = localStorage.getItem('token')
        return typeof token === 'string' ? token : null
    } catch (error) {
        return null
    }
}

const initialAuthState = {
    token: getTokenFromStorage(),
    user: null,
    permissions: [],
    isAuthorized: false,
    failedToLoadUserByToken: false,
    otpSession: null, // NEW
    isInitializing: true, 
}

export const authSlice = createSlice({
    name: 'auth',
    initialState: initialAuthState,
    reducers: {
        login: (state, action) => {
            const { accessToken, user, permissions } = action.payload
            state.token = accessToken
            state.isAuthorized = true
            state.user = user
            state.permissions = permissions
        },
        logout: (state, action) => {
            localStorage.removeItem('token')
            state.token = null
            state.user = null
            state.isAuthorized = false
        },
        loadUserByToken: (state, action) => {
            const { user, permissions } = action.payload
            state.actionLoading = false
            state.user = user
            state.isAuthorized = true
            state.permissions = permissions
            state.isInitializing = false
        },
        setOtpSession: (state, action) => {
            state.otpSession = action.payload;
          },
          clearOtpSession: (state) => {
            state.otpSession = null;
          },
          setResetToken: (state, action) => {
            if (!state.otpSession) state.otpSession = {};
            state.otpSession.reset_token = action.payload;
          },
          setInitializationComplete: (state) => {
            state.isInitializing = false;
          },
          
    },
})
export const { login, logout, loadUserByToken, setOtpSession, clearOtpSession, setResetToken, setInitializationComplete } = authSlice.actions
export default authSlice.reducer
